export const EN_LANG = {
    copyright_name:"Copyright",
    copyright:"© Copyright plan-b architects. All rights reserved.",
    title:"Plan-b architects",
    desc:"Architectural studio based in Prague and Bratislava.",
    projects:"Projects",
    publications:"Publications",
    contact:"Contact"
};
